import React, { useState } from "react"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import Button from "../../../shared/components/atoms/button/button"
import "./frequently-questions.scss"

const FrequentlyQuestions = props => {
  const { params, mobile } = props

  const [activeTabs, setActiveTabs] = useState([])

  const handleActiveTabs = tab => {
    const tabs = activeTabs
    const isOpen = activeTabs.findIndex(i => i === tab)
    if (isOpen === -1) {
      tabs.push(tab)
    } else {
      tabs.splice(isOpen, 1)
    }
    setActiveTabs([...tabs])
  }

  const linkIwantAskQuestion = {
    "es-BO": "https://www.instagram.com/nosotrasbolivia/",
    "es-CO": "https://www.tiendanosotras.com/pagina/preguntas_frecuentes/",
    "es-EC": "https://www.tiendanosotras.com.ec/preguntas-frecuentes/",
  }[process.env.LOCALE]

  return (
    <section className="f-questions-section-product">
      <div className="f-background">
        <div className="f-questions-section-container">
          <TitleTab
            className={"f-TitleTab f-TitleTab-pink"}
            title={mobile ? "Preguntas frecuentes" : "Preguntas frecuentes"}
          />

          <div className="f-questions-section-question">
            {params.preguntasFrecuentes.map((preguntaFrecuente, i) => {
              return (
                <div
                  onClick={() => handleActiveTabs(i)}
                  className="f-questions-section-question-container"
                  key={`question-${i}`}
                >
                  <span
                    className={`f-questions-section-question-container-arrow ${
                      activeTabs.includes(i) ? "active" : ""
                    }`}
                  />
                  <b>{preguntaFrecuente.titulo}</b>
                  <p className={`${activeTabs.includes(i) ? "active" : ""}`}>
                    {preguntaFrecuente.respuesta}
                  </p>
                </div>
              )
            })}
          </div>

          {process.env.LOCALE !== "es-CL" && (
            <Button
              title="Ver mas preguntas"
              className="new-dark-blue"
              onClick={() => {
                window.open(linkIwantAskQuestion, "_blank")
              }}
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default FrequentlyQuestions
